import { Toast } from "vant";
  // 打包前看readme文件
export const mixins = {
  data() {
    return {
      urlList: [
        {
          url: "https://d3k10r508d7uc7.cloudfront.net/",
          icon: require("./../assets/png/app-hjll.webp"),
          name: "hjll",
          time: 0,
        },
        {
          url: "https://dgr6bi6zb7ltn.cloudfront.net/",
          icon: require("./../assets/png/app-yms.webp"),
          name: "yms",
          time: 0,
        },
        {
          url: "https://d1ovb7sx4hk7nf.cloudfront.net/",
          icon: require("./../assets/png/app-pornhub.webp"),
          name: "pornhub",
          time: 0,
        },
        {
          url: "https://d199wmlukw3tbn.cloudfront.net/",
          icon: require("./../assets/png/app-llll.webp"),
          name: "lld2",
          time: 0,
        },
        {
          url: "https://d10eqmpodti1y0.cloudfront.net/",
          icon: require("./../assets/png/app-haose.webp"),
          name: "haose",
          time: 0,
        },
        {
          url: "https://d1jur0h6hco4nm.cloudfront.net/",
          icon: require("./../assets/png/app-mdcm.webp"),
          name: "mdcm",
          time: 0,
        },
        {
          url: "https://d16tyzxq80tftj.cloudfront.net/",
          icon: require("./../assets/png/app-lld.webp"),
          name: "lld",
          time: 0,
        },
        {
          url: "https://d12erlhho52wwl.cloudfront.net/",
          icon: require("./../assets/png/app-bilibili.webp"),
          name: "bilibili",
          time: 0,
        },
        {
          url: "https://d3l2zyco94a20v.cloudfront.net/",
          icon: require("./../assets/png/app-anwang.webp"),
          name: "anwang",
          time: 0,
        },
        {
          url: "https://d3q4qnfxr02qv7.cloudfront.net",
          icon: require("./../assets/png/app-pornhub2.webp"),
          name: "pornhub2",
          time: 0,
        },
        {
          url: "https://dyhsql1f3jtzu.cloudfront.net/",
          icon: require("./../assets/png/app-xvideo.webp"),
          name: "xvideo",
          time: 0,
        },
        {
          url: "https://d1cb4gs3z5z1h4.cloudfront.net/",
          icon: require("./../assets/png/app-boduo.webp"),
          name: "boduo",
          time: 0,
        },
        {
          url: "https://d13v86hw7rdi2c.cloudfront.net/",
          icon: require("./../assets/png/app-yjmh.webp"),
          name: "yjmh",
          time: 0,
        },
        {
          url: "https://ds1uyo6hbrkp1.cloudfront.net/",
          icon: require("./../assets/png/app-ks.webp"),
          name: "ks",
          time: 0,
        },
        {
          url: "https://dtiboghbn7bij.cloudfront.net/",
          icon: require("./../assets/png/app-qysq.webp"),
          name: "qysq",
          time: 0,
        },
        {
          url: "https://d2sl53pvx7ix4v.cloudfront.net/",
          icon: require("./../assets/png/app-txmh.webp"),
          name: "txmh",
          time: 0,
        },
        {
          url: "https://d1edaflonml6ab.cloudfront.net/",
          icon: require("./../assets/png/app-lieqi.webp"),
          name: "91lq",
          time: 0,
        },
        {
          url: "https://d3hk0pccwojxn6.cloudfront.net/",
          icon: require("./../assets/png/app-91sm.webp"),
          name: "91sm",
          time: 0,
        },
        {
          url: "https://d28hxya9djb0ev.cloudfront.net/",
          icon: require("./../assets/png/app-yly.webp"),
          name: "yly",
          time: 0,
        },
        {
          url: "https://d1sulhznueyu5e.cloudfront.net/",
          icon: require("./../assets/png/app-tangxin.webp"),
          name: "tangxin",
          time: 0,
        },
        {
          url: "https://d24948ymtg5jrl.cloudfront.net/",
          icon: require("./../assets/png/app-paofu.webp"),
          name: "paofu",
          time: 0,
        },
        {
          url: "https://d330153cbiv3wt.cloudfront.net/",
          icon: require("./../assets/png/app-jljd.webp"),
          name: "jljd",
          time: 0,
        },
        {
          url: "https://drivczvs3donr.cloudfront.net/",
          icon: require("./../assets/png/app-hls.webp"),
          name: "hls",
          time: 0,
        },
      ], // 域名数组
      ping: 1,
      timer: null,
      showImg: true,
      addressUrl: "cao.gg",
    };
  },
  mounted() {
    this.addressUrl = window.location.host;
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    init() {
      this.timer = setInterval(() => {
        this.ping++;
      }, 100);
    },
    autoTest(item, index) {
      if (this.ping <= 10) {
        item.time = this.ping * 10;
      } else {
        item.time = this.ping * 100;
      }
      if (index == this.urlList.length - 1) {
        clearInterval(this.timer);
      }
    },
    jumpUrl(url) {
      const dc = process.env.VUE_APP_WEB_DC || 985
      window.open(url + '?dc=' + dc);
    },
    reset() {
      this.urlList = this.urlList.map((item) => {
        item.time = 0;
        return item;
      });
      this.showImg = false;
      this.$nextTick(() => {
        this.showImg = true;
      });
      this.ping = 1;
      this.init();
    },
    doCopy() {
      let req = this.addressUrl;
      this.$copyText(req).then(
        () => {
          Toast("复制成功");
        },
        () => {
          Toast("复制失败");
        }
      );
    },
  },
};
